// ./src/components/features/EventRoomsInfoBadge/EventRoomsInfoBadge.tsx
import React from "react";
import { Text } from "@mantine/core";
import { Event, RecurringEvent, ScheduleEvent } from "@/utils";

export interface EventRoomsInfoBadgeProps {
  event: Event | RecurringEvent | ScheduleEvent | null | undefined;
}

export const EventRoomsInfoBadge: React.FC<EventRoomsInfoBadgeProps> = ({
  event,
}) => {
  if (!event) {
    return null;
  }

  const hasRooms = Array.isArray(event.rooms) && event.rooms.length;

  if (!hasRooms) {
    return (
      <Text size="xs" c="dimmed">
        No rooms assigned
      </Text>
    );
  }

  const rooms = event.rooms?.map((room: any) => room.name).join(", ");

  return <Text>{rooms}</Text>;
};
